import { CheckIcon } from "@heroicons/react/20/solid";
import {
    BusinessProfileStep,
    businessProfileStepLabels,
    businessProfileSteps,
} from "@sp-crm/core";
import { SecondaryCompactButton } from "components/ui/secondary-button";
import React from "react";

const markerClasses =
    "inline-flex items-center justify-center min-w-[1.25rem] rounded-full px-1 text-[10px] tabular-nums leading-4";

const CompleteStepMarker: React.FC = () => (
    <span className={`${markerClasses} bg-green-100 text-green-700`}>
        <CheckIcon className="w-3 h-3" aria-hidden />
        <span className="sr-only">Complete:</span>
    </span>
);

const NumberedStepMarker: React.FC<{ number: number }> = props => (
    <span className={`${markerClasses} bg-black/10`}>{props.number}</span>
);

interface BusinessProfileStepperProps {
    currentStep: BusinessProfileStep;
    completedSteps: BusinessProfileStep[];
    onSelect: (step: BusinessProfileStep) => void;
}

export const BusinessProfileStepper: React.FC<BusinessProfileStepperProps> = props => {
    const { currentStep, completedSteps, onSelect } = props;
    const currentIndex = businessProfileSteps.indexOf(currentStep);

    return (
        <nav className="flex items-center gap-2 flex-wrap">
            {businessProfileSteps.map((step, index) => (
                <React.Fragment key={step}>
                    {index > 0 ? (
                        <div
                            className={`hidden sm:block h-px flex-1 ${
                                index <= currentIndex ? "bg-brand-400" : "bg-gray-200"
                            }`}
                        />
                    ) : null}
                    <SecondaryCompactButton
                        type="button"
                        selected={step === currentStep}
                        onClick={() => onSelect(step)}>
                        <span className="inline-flex items-center gap-1.5">
                            {completedSteps.includes(step) && step !== currentStep ? (
                                <CompleteStepMarker />
                            ) : (
                                <NumberedStepMarker number={index + 1} />
                            )}
                            {businessProfileStepLabels[step]}
                        </span>
                    </SecondaryCompactButton>
                </React.Fragment>
            ))}
        </nav>
    );
};
